import logger from '../../lib/logger';
/**
 * WebGPU/WebGL2 Engine Initialization
 * Tries WebGPU first, falls back to WebGL2 for compatibility
 */
import * as BABYLON from '@babylonjs/core';
import { WebGPUEngine } from '@babylonjs/core/Engines/webgpuEngine';

let engineType = 'pending';

/**
 * Initialize the Babylon.js engine with WebGPU support (WebGL2 fallback)
 * @param {HTMLCanvasElement} canvas 
 * @returns {Promise<BABYLON.Engine>}
 */
export async function createEngine(canvas) {
  // Try WebGPU first
  if (navigator.gpu) {
    try {
      const adapter = await navigator.gpu.requestAdapter({ powerPreference: 'high-performance' });
      if (adapter) {
        const engine = new WebGPUEngine(canvas, {
          powerPreference: 'high-performance',
          antialias: true,
          stencil: true,
          preserveDrawingBuffer: true,
          setMaximumLimits: true
        });
        await engine.initAsync();
        engineType = 'WebGPU';
        logger.log('WebGPU engine initialized successfully');
        return engine;
      }
    } catch (error) {
      logger.warn('WebGPU initialization failed, falling back to WebGL2:', error.message);
    }
  }
  
  // Fallback to WebGL2
  const engine = new BABYLON.Engine(canvas, true, {
    preserveDrawingBuffer: true,
    stencil: true
  });
  engineType = 'WebGL2';
  logger.log('WebGL2 engine initialized (fallback)');
  return engine;
}

/**
 * Get the current engine type
 * @returns {'WebGPU' | 'WebGL2' | 'pending'}
 */
export function getEngineType() {
  return engineType;
}

/**
 * Check if WebGPU is available in this browser
 * @returns {boolean}
 */
export function isWebGPUAvailable() {
  return !!navigator.gpu;
}
